import { all } from 'redux-saga/effects';

import { requestAndAuthFlowHandler } from './requestAndAuthFlowHandler';
import { cardsFiltersInitializer } from './cardsFiltersInitializer';
import { reportLoadHandler } from './reportDispatcherOnLoad';

export function* sagas(): Generator<any, void, any> {
    yield all([...requestAndAuthFlowHandler, ...cardsFiltersInitializer, ...reportLoadHandler]);
}
